import React from "react";
import { PrefillInput } from "@components/input";

export const StreetNumber = () => (
  <PrefillInput
    title="Street Number"
    placeholder="Street Number"
    name="streetNumber"
  />
);